var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountUpgrade = function SvgAccountUpgrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.186 22.234H2.854a1.71 1.71 0 0 0-1.711 1.71v2.883c0 .945.766 1.711 1.71 1.711h26.333a1.71 1.71 0 0 0 1.711-1.71v-2.883a1.71 1.71 0 0 0-1.71-1.711Z",
    fill: "#CCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.897 26.827v-2.882a1.705 1.705 0 0 0-1.71-1.711H14.7l-1.457.403 4.432 4.432a5.009 5.009 0 0 0 3.54 1.438h7.971a1.705 1.705 0 0 0 1.711-1.68Z",
    fill: "#999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.767 13.81h3.137v9.552a1.785 1.785 0 0 0 1.785 1.786h10.662a1.785 1.785 0 0 0 1.785-1.786V13.81h3.137a.62.62 0 0 0 .459-1.097L16.479 2.473a.657.657 0 0 0-.918 0L5.308 12.712a.62.62 0 0 0 .46 1.097Z",
    fill: "#D8D8D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.904 13.81H5.767a.62.62 0 0 1-.459-1.097l10.253-10.24a.657.657 0 0 1 .459-.187v22.861h-5.331a1.785 1.785 0 0 1-1.785-1.785V13.81Z",
    fill: "#fff"
  })));
};
export default SvgAccountUpgrade;